module.exports = __webpack_public_path__ + "static/media/spades_Q.9a5cc80f.png";